import React from "react";
import { Alert } from "@paysera/react-common";

import Department from "./component/Department";
import { Spinner, CountryDropdown, DepartmentDropdown } from "../shared/components";
import useGetCareers from "./hooks/useGetCareers";
import useFilterByDepartment from "./hooks/useFilterByDepartment";
import { PREFERRED_CAREER_COUNTRIES } from '../shared/config/constants';

const Careers = () => {
  const {
    careers,
    isLoading,
    error,
    handleCountryChange,
  } = useGetCareers();

  const {
    filteredCareers,
    departments,
    handleDepartmentChange,
  } = useFilterByDepartment(careers);


  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return <Alert bsStyle="danger">{error}</Alert>
  }

  return (
    <>
      <div className="filters-container">
          <CountryDropdown
            onCountryChange={handleCountryChange}
            availableCountries={PREFERRED_CAREER_COUNTRIES}
          />
        {!!departments.length && (
            <DepartmentDropdown
              departments={departments}
              onDepartmentChange={handleDepartmentChange}
          />
        )}
      </div>
      <div className="careers-list">
        {filteredCareers.map((elem) => (
          <Department
            key={elem?.department?.id}
            department={elem?.department?.name}
            careers={elem?.careers}
          />
        ))}
      </div>
    </>
  );
};

export default Careers;
